<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed ? 'logo-collapse-width' : 'logo-width'">
				<div class="leftFisxe">
					<img v-if="!collapsed" @click="goHome('/homePage')" src="../images/logo.png" alt="" />
					<img v-else @click="goHome('/homePage')" style="width:40px;height:30px;margin-right:0px;" src="../images/bluelogo.png" alt="" />
				</div>
				<div v-if="!collapsed" class="txts1">| 运营平台</div>
				<i></i>
			</el-col>
			<el-col :span="10">
				<div class="tools" @click.prevent="collapsed = !collapsed"><img src="../images/zhankaihome.png" alt="" srcset="" style="width:22px;height:20px;" /></div>
			</el-col>
			<el-col :span="4" class="userinfo">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link userinfo-inner">
						{{ sysUserName }}
						<span class="el-icon-caret-bottom"></span>
					</span>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item @click.native="setRouter('set')">设置</el-dropdown-item> -->
						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<div class="">
			<div class="cont">
				<div
					class="list hovsList1"
					v-for="(item, index) in homeList"
					:key="index"
					:class="item.iconActive"
					@mouseover="menuOver(index)"
					@mouseout="menuOut(index)"
					@click="setRouter(item, index)"
				>
					<img src="../../static/homepageImg/yunyin.png" alt="" class="Icon" />
					<p :style="{ color: index == listIndex ? '#00ADEE' : '#373D41' }" class="tit">{{ item.funcName }}</p>
				</div>
				<div
					class="list"
					v-for="(items, index2) in childList"
					:key="index2 + homeList.length"
					@mouseover="menuOver2(index2)"
					:class="items.iconActive"
					@mouseout="menuOut2(index2)"
					@click="setRouter2(items.adminUrl, items.platId, items.platName)"
				>
					<!-- <img :src="listIndex2==index2?httpUrl+items.iconActive:httpUrl+items.icon" alt="" class="Icon"> -->
					<img :src="imgsrc + items.icon" alt="" class="Icon" />
					<p :style="{ color: index2 == listIndex2 ? items.color : '#373D41' }" class="tit">{{ items.platName }}</p>
				</div>
			</div>
		</div>
	</el-row>
</template>

<script>
import autoRouter from '../routes';
import { convertTree, convertAuthor } from '../common/js/util';
export default {
	data() {
		return {
			imgsrc: '../../static/homepageImg/',
			listIndex: 'author',
			listIndex2: 'author2',
			home: true,
			homeList: [],
			childList: [],
			httpUrl: '',
			collapsed: false,
			sysUserName: '',
			sysUserAvatar: '',
			token: '',
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},
			mapRoute: []
		};
	},
	methods: {
		setRouter(item, index) {
			sessionStorage.removeItem('platlist'); //删除
			sessionStorage.removeItem('platID'); //删除
			sessionStorage.removeItem('adminUrl'); //删除
			this.$cookie.set('menuIndex', index, { expires: 1 });
			this.$store.commit('SET_ROUTES', []); //清空上个路由
			let routes = sessionStorage.getItem('menuList'); //取
			routes = JSON.parse(routes);
			this.mapRoute = [];
			convertTree(routes[index].childMenu, { children: 'childMenu' }, this.mapRoute); //1获取到的每一个模块的路由,2,判断有没有子节点重新递归
			let ruter = convertAuthor(autoRouter, this.mapRoute); //第一个参数是自己的路由  2接口获取的初始化路由，路由筛选 最终得出一个路由表
			if (ruter && ruter.length > 0) {
				this.$nextTick(() => {
					this.$store.commit('SET_ROUTES', ruter);
					this.$router.addRoutes(ruter);
					this.$router.push(ruter[0].redirect); //跳转首页
				});
				ruter.unshift({
					path: '/',
					redirect: ruter[0].path
				});
			} else {
				this.$message({ message: '无可用路由', type: 'warning' });
			}
		},
		setRouter2(adminUrl, platID, platName) {
			if (platID == 49) {
				window.location.href = adminUrl + '?token=' + this.token + '&source=' + 'operate';
				return false;
			}
			// if(platID == 60){	//测试不要，正式要
			// 	window.location.href= adminUrl	+'?token='+this.token + '&source=' + 'operate'
			// 	return false;
			// }
			this.$cookie.set('menuIndex', platID, { expires: 1 });
			this.$store.commit('SET_ROUTES', []); //清空上个路由
			var _this = this;
			sessionStorage.setItem('platID', platID);
			sessionStorage.setItem('platName', platName);
			sessionStorage.setItem('adminUrl', adminUrl);
			var getPlatAuthByPlatIdData = { platId: platID };
			_this.$author.getPlatAuthByPlatId(getPlatAuthByPlatIdData).then(res => {
				if (res.result == '00000000') {
					sessionStorage.setItem('separe', res.data.separe);
					sessionStorage.setItem('buttonCodes', res.data.buttonCodes);
					this.mapRoute = [];
					sessionStorage.setItem('platlist', JSON.stringify(res.data.menuList));
					convertTree(res.data.menuList, { children: 'childMenu' }, this.mapRoute);
					let ruter = convertAuthor(autoRouter, this.mapRoute);
					if (ruter && ruter.length > 0) {
						this.$nextTick(() => {
							this.$store.commit('SET_ROUTES', ruter);
							this.$router.addRoutes(ruter);
							this.$router.push(ruter[0].redirect);
						});
						ruter.unshift({ path: '/', redirect: ruter[0].path });
					} else {
						this.$router.push('/index');
					}
				} else {
					_this.$message({ message: res.msg, type: 'error' });
				}
			});
		},
		goHome(name) {
			this.$router.push(name);
			if (sessionStorage.getItem('id')) {
				window.sessionStorage.removeItem('id');
			}
		},
		menuOver(ind) {
			this.listIndex = ind;
		},
		menuOut(ind) {
			this.listIndex = 'author';
		},
		menuOver2(ind1) {
			this.listIndex2 = ind1;
		},
		menuOut2(ind1) {
			this.listIndex2 = 'author2';
		},
		//退出登录
		logout: function() {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {})
				.then(() => {
					sessionStorage.clear();
					localStorage.clear()
					_this.$router.push('/login');
				})
				.catch(() => {});
		}
	},
	created() {
		this.httpUrl = this.Imgurl;
		if (sessionStorage.authorityInfo) {
			this.data = JSON.parse(sessionStorage.authorityInfo);
			this.homeList = this.data.menuList;
			this.childList = this.data.platList;
		}
	},
	mounted() {
		var user = sessionStorage.getItem('user');
		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.userName || '';
			this.sysUserAvatar = user.avatar || '';
			this.token = user.token;
		}
		sessionStorage.setItem('platName', '');
	}
};
</script>

<style scoped lang="scss">
@import '~scss_vars';
.hovsList1:hover {
	background: url('../../static/border/1.png') no-repeat !important;
	background-size: 100% 100%;
	background: #ffffff;
}
.list48_1:hover {
	background: url('../../static/border/2.png') no-repeat !important;
	background-size: 100% 100%;
	background: #ffffff;
}
.list49_1:hover {
	background: url('../../static/border/3.png') no-repeat !important;
	background-size: 100% 100%;
}
.list50_1:hover {
	background: url('../../static/border/4.png') no-repeat !important;
	background-size: 100% 100%;
}
.list51_1:hover {
	background: url('../../static/border/5.png') no-repeat !important;
	background-size: 100% 100%;
}
.list52_1:hover {
	background: url('../../static/border/6.png') no-repeat !important;
	background-size: 100% 100%;
}
.list53_1:hover {
	background: url('../../static/border/7.png') no-repeat !important;
	background-size: 100% 100%;
}
.list54_1:hover {
	background: url('../../static/border/8.png') no-repeat !important;
	background-size: 100% 100%;
}
.list55_1:hover {
	background: url('../../static/border/9.png') no-repeat !important;
	background-size: 100% 100%;
}
.list56_1:hover {
	background: url('../../static/border/10.png') no-repeat !important;
	background-size: 100% 100%;
}
.list6_1:hover {
	background: url('../../static/border/10.png') no-repeat !important;
	background-size: 100% 100%;
}
.el-dropdown-menu__item--divided {
	border: none !important;
	margin-top: 0px !important;
}
.logo {
	width: 198px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
}
.cont {
	width: 1230px;
	margin: 0 auto;
	min-height: 100vh;
	// padding:20px 0px;
	// position: absolute;
	// left: calc(50% - 472px) ;
	// top:calc(50% - 202px);
}
.list {
	width: 224px;
	height: 224px;
	background: #ffffff;
	float: left;
	margin: 22px 20px 0px 0px;
	cursor: pointer;
	transition: all 0.1s linear;
}
.list:hover {
	box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
	transform: translate3d(0, -3px, 0);
}
.Icon {
	width: 108px;
	height: 108px;
	display: block;
	margin: 31px auto 0;
}
.tit {
	font-family: PingFangSC-Regular;
	font-size: 18px;
	color: #000000;
	letter-spacing: 0;
	text-align: center;
}
.container {
	background: #f9f9f9;
	.header {
		height: 60px;
		line-height: 60px;
		background: $color-primary;
		box-shadow: 0 0 25px #cac6c6;
		border-bottom-width: 1px;
		border-bottom-style: solid;
		border-color: #dcdcdc;
		color: #303133;
		margin-bottom: 40px;
		.userinfo {
			text-align: right;
			padding-right: 35px;
			float: right;
			.userinfo-inner {
				cursor: pointer;
				img {
					width: 40px;
					height: 40px;
					border-radius: 20px;
					margin: 10px 0px 10px 10px;
					float: right;
				}
			}
		}
		.logo {
			width: 230px;
			height: 60px;
			font-size: 22px;
			border-color: #dcdcdc;
			border-right-width: 1px;
			border-bottom-width: 1px;
			border-right-style: solid;
			border-bottom-style: solid;
			img {
				display: block;
				cursor: pointer;
				width: 100px;
				margin-right: 5px;
			}
			.txts1 {
				font-size: 18px;
				color: #949494;
				height: 56px;
				cursor: pointer;
			}
		}
		.logo-width {
			width: 230px;
		}
		.logo-collapse-width {
			width: 60px;
		}
		.tools {
			padding: 5px 23px;
			width: 14px;
			height: 60px;
			line-height: 60px;
			cursor: pointer;
		}
	}
	.main {
		display: flex;
		// background: #324057;
		position: absolute;
		top: 60px;
		bottom: 0px;
		overflow: hidden;
		aside {
			flex: 0 0 230px;
			width: 230px;
			// position: absolute;
			// top: 0px;
			// bottom: 0px;
			.el-menu {
				height: 100%;
			}
			.collapsed {
				width: 60px;
				.item {
					position: relative;
				}
				.submenu {
					position: absolute;
					top: 0px;
					left: 60px;
					z-index: 99999;
					height: auto;
					display: none;
				}
			}
		}
		.menu-collapsed {
			flex: 0 0 60px;
			width: 60px;
		}
		.menu-expanded {
			flex: 0 0 230px;
			width: 230px;
		}
		.content-container {
			// background: #f1f2f7;
			flex: 1;
			// position: absolute;
			// right: 0px;
			// top: 0px;
			// bottom: 0px;
			// left: 230px;
			overflow-y: scroll;
			padding: 20px;
			.breadcrumb-container {
				//margin-bottom: 15px;
				.title {
					width: 200px;
					float: left;
					color: #475669;
				}
				.breadcrumb-inner {
					float: right;
				}
			}
			.content-wrapper {
				background-color: #fff;
				box-sizing: border-box;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// homePage.vue?4b31bcc1